import React from 'react';
import { useTranslation } from 'react-i18next';

import ShareButton from 'components/ShareButton';
import { useGame } from 'common/state';
import { getChart, getAttemptCount, getHintCount } from 'common/logic';

function End() {
  const [gameState] = useGame();
  const { t } = useTranslation();

  const attemptCount = getAttemptCount(gameState);
  const hintCount = getHintCount(gameState);
  const chart = getChart(gameState);

  return (
    <div className="end-msg">
      <p>
        <b>{t('gameScreen.congratulations')}</b>
      </p>
      <p>
        {t('gameScreen.youGotItIn')} <b>{attemptCount}</b>{' '}
        {t('gameScreen.attempts')}
        {hintCount > 0 && (
          <>
            {' '}
            {t('gameScreen.and')} <b>{hintCount}</b>{' '}
            {t('gameScreen.hints', { count: hintCount })}
          </>
        )}
        .
      </p>
      <div className="chart-wrapper">
        <div className="chart">{chart}</div>
      </div>
      <div className="end-share-wrapper">
        <ShareButton />
      </div>
    </div>
  );
}

export default End;
